module.exports = __webpack_public_path__ + "img/Volterres_120X35.f78a9582.png";